<template>
  <div v-if="store.isShutdownVisible" class="shutdown-timer">
    <i class="pi pi-exclamation-circle"></i>
    <span>{{ store.shutdownDisplayMessage }}</span>
  </div>
</template>

<script setup lang="ts">
import { useSystemEventsStore } from '@/stores/systemEvents'

const store = useSystemEventsStore()
</script>

<style scoped lang="scss">
.shutdown-timer {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 14px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  color: #fff;
  font-size: 13px;
  font-family: inherit;

  .pi-exclamation-circle {
    font-size: 14px;
    color: #ffbe44;
    animation: blink 2s ease-in-out infinite;
  }
}

@keyframes blink {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.2; transform: scale(0.9); }
}
</style>
